<main style="background-color: white;">
    <div style="padding-top: 10%;padding-left: 10%;">
        <h2>I AM AN END CUSTOMER INTERESTED IN BATTERIES</h2>
    
    <mat-stepper labelPosition="bottom" #stepper linear="true" >
        <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
            <ng-template matStepperIcon="edit">
                <mat-icon>✓</mat-icon>
              </ng-template><ng-template matStepLabel>SYSTEM INFORMATION</ng-template>
            <div class="mt-5 mb-4" style="color:black">
                <h2><b>SYSTEM INFORMATION</b></h2>
            </div>
            <h4 style="margin: 32px 0 16px;" class="mb-4 mt-4"><b>LOCATION</b></h4>
            <div class="row">
                <div class="col-8">
                    <mat-label class="d-block mb-2"><b>Address *</b></mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput placeholder="Enter your address" formControlName="address" required />
                    </mat-form-field>
                </div>
                
            </div>
              <div class="row">
                <div class="col-3">
                    <mat-label class="d-block mb-2"><b>Zip code *</b></mat-label>
                    <mat-form-field appearance="outline" class="mt-2">
                        <input matInput placeholder="Enter your zip code" formControlName="zip_code" required />
                      </mat-form-field>
                </div>
                <div class="col-3">
                    <mat-label class="d-block mb-2"><b>City *</b></mat-label>
                    <mat-form-field appearance="outline" class="mt-2">
                        <input matInput placeholder="Enter your city" formControlName="city" required />
                      </mat-form-field>
                </div>
                <div class="col-3">
                    <mat-label class="d-block mb-2"><b>Country *</b></mat-label>
                    <mat-form-field appearance="outline" class="mt-2">
                        <mat-select formControlName="country" required>
                            <mat-option *ngFor="let country of countries" value="{{ country.name }}">{{country.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
              </div>

            <div>
            <div class="row">
                <div class="col-10">

                </div>
                <div class="col-2">
                    <button mat-button matStepperNext>
                        <img src="/assets/img/next.png" alt="">
                    </button>
                </div>
            </div>
            
            </div>
        </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
            <ng-template matStepLabel>ENERGY DETAILS</ng-template>
            <div>
                <div>
                    <h4 style="margin: 32px 0 16px;" class="mb-4 mt-4"><b>ENERGY INFORMATION</b></h4>
                  </div>

                  <div class="row">
                    <div class="col-4">
                        <mat-label class="mb-2"><b>Average monthly energy consumption *</b></mat-label>
                        <mat-form-field appearance="outline" class="mt-2">
                            <input type="number" matInput placeholder="Enter energy consumption" formControlName="average_energy_consumption" required />
                            <span style="margin-right:5px;" matSuffix>kWh</span>
                          </mat-form-field>
                    </div>
                    <div class="col-3">
                        <mat-label class="mb-2"><b>Desired system capacity</b></mat-label>
                        <mat-form-field appearance="outline" class="mt-2">
                            <input type="number" matInput placeholder="Enter system capacity" formControlName="desired_capacity" />
                            <span style="margin-right:5px;" matSuffix>kWh</span>
                          </mat-form-field>
                    </div>
                  </div>
            
                  <div class="row">
                    <div class="col-3">
                        <mat-label class="mb-2"><b>Intallation timeline</b></mat-label>
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="installation_timeline">
                                <mat-option value="ASAP">ASAP</mat-option>
                                <mat-option value="Within 6 months">Within 6 months</mat-option>
                                <mat-option value="12 months">Within 12 months</mat-option>
                                <mat-option value="Later/unkown">Later/unkown</mat-option>
                                
                            </mat-select>
                        </mat-form-field>
                    </div>
                  </div>
                  
                <div class="mt-5 mb-4" style="color:black">
                    <h2><b>ENERGY DETAILS</b></h2>
                </div>

                <div class="row mb-4">
                    <div class="col-4">
                        <p class="mb-2"><b>Do you have an existing energy generation source?</b></p>
                        <mat-radio-group formControlName="have_energy_source" (change)="onEnergySourceChange($event.value)">
                            <mat-radio-button class="me-4" value="Yes">Yes</mat-radio-button>
                            <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="col-4" *ngIf="showInstalledPower">
                        <p class="mb-2"><b>Specify installed power</b></p>
                        <mat-form-field appearance="outline">
                            <input matInput type="number" formControlName="installed_power">
                            <span style="margin-right:5px;" matSuffix>kW</span>
                        </mat-form-field>
                    </div>
                    <div class="col-4" *ngIf="showInstalledPower">
                        
                    </div>
                    <div class="col-4">
                        <p class="mb-2"><b>Specify coupling type</b></p>
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="coupling_type">
                                <mat-option value="AC coupling">AC coupling</mat-option>
                                <mat-option value="DC coupling">DC coupling</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-4"  *ngIf="!showInstalledPower"></div>
                    <div class="col-4">
                        <p class="mb-2"><b>Primary application</b></p>
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="primary_application" multiple>
                                <mat-option value="Backup">Backup</mat-option>
                                <mat-option value="Avoid grid upgrades">Avoid grid upgrades</mat-option>
                                <mat-option value="Peak Shaving">Peak Shaving</mat-option>
                                <mat-option value="Self-consumption">Self-consumption</mat-option>
                                <mat-option value="Arbitrage / Time shifting">Arbitrage / Time shifting</mat-option>
                                <mat-option value="Grid services">Grid services</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-4"  *ngIf="showInstalledPower"></div>
                    <div class="col-4">
                        <p class="mb-2"><b>On-grid or off-grid*</b></p>
                        <mat-radio-group formControlName="on_grid_off_grid">
                            <mat-radio-button class="me-4" value="On-grid">On-grid</mat-radio-button>
                            <mat-radio-button class="me-4" value="Off-grid">Off-grid</mat-radio-button>
                            <mat-radio-button value="On-Grid+Backup">On-Grid+Backup</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row">
                    <div>
                        <h4 style="margin: 32px 0 16px;" class="mb-4 mt-4"><b>CONSUMPTION DETAILS</b></h4>
                    </div>

                    <div class="row mb-2">
                        <div class="col-3">
                            <mat-label><b>Average energy tariff</b></mat-label>
                            <mat-form-field appearance="outline" class="mt-2" >
                                <input matInput type="number" placeholder="Enter Energy consumption" formControlName="energy_consumption" />
                                <span style="margin-right:5px;" matSuffix>€/kWh</span>
                              </mat-form-field>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-4">
                            <mat-label><b>Maximum allowed import (from the grid)</b></mat-label>
                            <mat-form-field appearance="outline" class="mt-2" >
                                <input matInput type="number" placeholder="Enter allowed import" formControlName="allowed_import" />
                                <span style="margin-right:5px;" matSuffix>kW</span>
                              </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-label><b>Maximum allowed export (from the grid)</b></mat-label>
                            <mat-form-field appearance="outline" class="mt-2" >
                                <input matInput type="number" placeholder="Enter allowed export" formControlName="allowed_export" />
                                <span style="margin-right:5px;" matSuffix>kW</span>
                              </mat-form-field>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-md-12 col-sm-12 col-lg-6">
                            <div class="row" style="background-color: #f2f2f2; align-items: center; padding: 8px;">
                                <div class="col-md-12 col-sm-12 col-lg-6">
                                    <mat-label><b>Consumption data</b></mat-label>
                                    <p>Upload half-hourly consumption file of the last full year.</p>
                                </div>
                                <div class="col-md-12 col-sm-12 col-lg-6">
                                    <input class="form-control" type="file" id="formFile" formControlName="end" (change)="fileSelectionChanged($event)">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="d-block col-6">
                            <mat-label><b>Other comments</b></mat-label>
                            <mat-form-field class="example-full-width" appearance="outline">
                                <textarea matInput formControlName="comment"></textarea>
                              </mat-form-field>
                        </div>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col-10">
                    </div>
                    <div class="col-2">
                        <button mat-button matStepperPrevious>
                            <img src="/assets/img/back.png" alt="">
                        </button>
                        <button mat-button matStepperNext>
                            <img src="/assets/img/next.png" alt="">
                        </button>
                    </div>
                </div>
            </div>
        </form>
        </mat-step>
        <mat-step [stepControl]="thirdFormGroup">
            <form [formGroup]="thirdFormGroup">
                <ng-template matStepLabel>CUSTOMER INFORMATION</ng-template>
                <div>
                    <div class="mt-5 mb-4" style="color:black">
                        <h2><b>CUSTOMER INFORMATION</b></h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <mat-label class="d-block mb-2"><b>First Name *</b></mat-label>
                        <mat-form-field appearance="outline" class="mt-2">
                            <input matInput placeholder="Enter name" formControlName="first_name" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-label class="d-block mb-2"><b>Last Name*</b></mat-label>
                        <mat-form-field appearance="outline" class="mt-2">
                            <input matInput placeholder="Enter last name" formControlName="last_name" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <mat-label class="d-block mb-2"><b>E-Mail *</b></mat-label>
                        <mat-form-field appearance="outline" class="mt-2">
                            <input matInput placeholder="Enter E-Mail" formControlName="email" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-label class="d-block mb-2"><b>Phone number *</b></mat-label>
                        <mat-form-field appearance="outline" class="mt-2">
                            <input matInput placeholder="Enter phone" formControlName="phone_number" />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-7">
                    </div>
                    <div class="col-2 text-end">
                        <button mat-button matStepperPrevious>
                            <img src="/assets/img/back.png" alt="">
                        </button>
                    </div>
                    <div class="col-3">
                        <button mat-button matStepperNext>
                            <button type="button" (click)="submit()" class="btn btn-dark"><b>REQUEST TO LEARN MORE</b></button>
                        </button>
                    </div>
                </div>
            </form>
        </mat-step>
    </mat-stepper>
</div>
</main>
